var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5225,
    y: 2.5225,
    width: 8.955,
    height: 10.955,
    rx: 1.31083,
    stroke: "#002A69",
    strokeWidth: 1.045
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6 3H10",
    stroke: "#002A69",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.88889L8.2134 5.72765C8.79303 5.28971 9.58315 5.25606 10.1979 5.64313C11.1305 6.23033 11.2934 7.52367 10.5354 8.32372L8.61158 10.3544C8.27929 10.7052 7.72071 10.7052 7.38842 10.3544L5.46458 8.32372C4.70663 7.52367 4.86948 6.23033 5.80208 5.64313C6.41685 5.25606 7.20697 5.28971 7.7866 5.72765L8 5.88889Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthTest);
export default __webpack_public_path__ + "static/media/Health_test.85ff4d3d16217f66c3c8b0055b63de1b.svg";
export { ForwardRef as ReactComponent };